export default "__VITE_ASSET__2b69d0b6__"